<style>
@media only screen and (max-width: 500px) {

    .table {
    display: flex;
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-content: flex-start;
}
.text-black {
    text-align: center;
    color: var(--dark) !important;
}

.table .table-striped{
    display: flex;
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;
}
thead{
    width: 30%;
    display: flex;
    flex-direction: row;
}

tr {
    width: 100%;
    display: flex;
    font-weight: normal !important;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
}


.table thead th {
    width: 100%;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
}

.table td {
    width: 100%;
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}


.table thead th, .table td {
    padding: 0px;
    min-height: 5em;
}

.table thead th, .table td {
    display: flex;
    padding: 9px;
    min-height: 5em;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
}

}
</style>

<template>
    <div id="joined-meetings">
        <section class="bg-light ftco-section">
            <div class="d-flex justify-content-center">
                <img src="@/assets/site/images/loader.gif" v-if="loader===true" class="img-fluid  loader-width" alt />
            </div>
            <div class="container" v-if="loader===false">
                <div class="row flex-lg-row flex-md-row">
                    <div class="col-md-12 mt-4">
                        <div class="card-body" style="min-height: 20rem;">
                            <h2 class="text-black">Registered Sessions</h2>
                            <div v-if="meetings.length<=0">
                                <p class="text-center text-primary mt-4">No Registered Sessions!!</p>
                            </div>
                            <table class="table table-striped" v-else>
                                <thead>
                                    <tr>
                                        <th>
                                            <h4>Title</h4>
                                        </th>
                                        <th>
                                            <h4>Type</h4>
                                        </th>
                                        <th>
                                            <h4>Date</h4>
                                        </th>
                                        <th>
                                            <h4>Time</h4>
                                        </th>
                                        <th>
                                            <h4>Duration</h4>
                                        </th>
                                        <th>
                                            <h4>Action</h4>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="meeting in meetings">
                                        <td>{{meeting.title}}</td>
                                        <td>{{meeting.type}}</td>
                                        <td>{{meeting.date_usa}}</td>
                                        <td>{{meeting.start_time}} to {{meeting.end_time}}</td>
                                        <td>{{meeting.duration}} mins</td>
                                        <td><b-button size="sm" variant="outline-danger mx-1" @click="CancelMeeting(meeting)"
                                class="fa fa-trash" v-b-popover.hover.top="'Cancel'"></b-button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "JoinedMeetings",
        data() {
            return {
                meetings: [],
                loader: false,
            };
        },
        created() {
            this.getUserMeetings();
        },
        methods: {
            getUserMeetings() {
                this.loader = true;
                var token = localStorage.getItem("userData");
                var userdata_array = JSON.parse(token);
                var api_token = userdata_array.token;
                let apiUrl = process.env.VUE_APP_URL + "api/session/getUserMeetings";
                fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                        Authorization: "Bearer " + api_token
                    },
                    body: JSON.stringify({
                        user_id: userdata_array.user.id,
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.meetings) {
                            this.loader = false;
                        }
                        this.meetings = data.meetings;
                    })
                    .catch(function (err) {
                        console.log("Fetch Error :-S", err);
                    });
            },
            CancelMeeting(meeting){
                var token = localStorage.getItem("userData");
                var userdata_array = JSON.parse(token);
                var api_token = userdata_array.token;
                let method_type = "";
                let fetch_url = "";
                method_type = "post";
                fetch_url = process.env.VUE_APP_URL + "api/meeting/cancel";
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "Do you want to cancel "+ meeting.title +" ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Close',
                    confirmButtonText: 'Yes, Cancel it!'
                }).then((result) => {
                    if (result.value) {
                        this.loader = true;
                        fetch(fetch_url, {
                            method: method_type,
                            headers: {
                                "content-type": "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                                Authorization: "Bearer " + api_token,
                            },
                            body: JSON.stringify({
                                meeting_id: meeting.id,
                            }),
                        })
                            .then((res) => res.json())
                            .then((data) => {
                                this.loader = false;
                                if (data.status === true) {
                                    this.$swal
                                        .mixin({
                                            toast: true,
                                            position: "top-end",
                                            showConfirmButton: false,
                                            timer: 3000,
                                        })
                                        .fire("Good to Go", data.message, "success");
                                    this.getUserMeetings();
                                    this.loader = false;
                                } else if (data.status === false) {
                                    this.loader = false;
                                    this.$swal
                                        .mixin({
                                            toast: true,
                                            position: "top-end",
                                            showConfirmButton: false,
                                            timer: 3000,
                                        })
                                        .fire("Error", "Session cancellation failed !", "error");
                                } else {
                                    this.loader = false;
                                    this.errors = data.errors;
                                }
                            })
                            .catch(function (err) {
                                this.$swal("Session cancellation", "Error : " + err.message, "error");
                            });
                        }
                        else{
                            this.loader = false;
                        }
                })   
                 
            },
        },
    }
</script>